import "./CardWhite.scss";

function CardWhite({ children }) {
  return <div className="CardWhite">{children}</div>;
}

export default CardWhite;
